// tslint:disable:max-line-length

import React from 'react';

export const ActionAddColumn = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path
        d="M6.6000399,14.000646 L0,14 L0,12 L6.02250792,12.000958 C6.08704765,12.715761 6.28834817,13.3911136 6.6000399,14.000646 Z M6.02238608,11.0003933 L0,11 L0,9 L6.59939174,9.00062188 C6.28787279,9.61020706 6.08674938,10.2855857 6.02238608,11.0003933 Z M11.5,6 C9.79185798,6 8.26558727,6.77868363 7.25679874,8.00044003 L0,8 L0,6 L11.5,6 L11.5,6 Z M12,3 L12,5 L0,5 L0,3 L12,3 Z M12,3.6504133e-13 L12,2 L0,2 L0,3.6504133e-13 L12,3.6504133e-13 Z"
        id="Combined-Shape"
      />
      <path
        d="M11.5,7 C13.9852814,7 16,9.01471863 16,11.5 C16,13.9852814 13.9852814,16 11.5,16 C9.01471863,16 7,13.9852814 7,11.5 C7,9.01471863 9.01471863,7 11.5,7 Z M12.076,9.1285 L10.924,9.1285 L10.924,10.9285 L9.196,10.9285 L9.196,12.0715 L10.924,12.0715 L10.924,13.8715 L12.076,13.8715 L12.076,12.0715 L13.804,12.0715 L13.804,10.9285 L12.076,10.9285 L12.076,9.1285 Z"
        id="Combined-Shape"
      />
    </svg>
  );
};
